import { Directive, ElementRef, HostListener, Input, Renderer2, OnInit } from '@angular/core';

@Directive({
    selector: '[charCounter]',
})
export class CharCounterDirective implements OnInit {
    @Input('charCounter') maxChars!: number;
    private counterElement: HTMLElement;

    constructor(private el: ElementRef, private renderer: Renderer2) {
        this.counterElement = this.renderer.createElement('span');
    }

    ngOnInit(): void {
        this.updateCounter(this.el.nativeElement.value.length);

        this.renderer.setStyle(this.counterElement, 'display', 'block');
        this.renderer.setStyle(this.counterElement, 'position', 'absolute');
        this.renderer.setStyle(this.counterElement, 'font-size', '12px');
        this.renderer.setStyle(this.counterElement, 'color', '#666');
        this.renderer.setStyle(this.counterElement, 'right', '12px');
        this.renderer.appendChild(this.el.nativeElement.parentNode, this.counterElement);
    }

    @HostListener('input', ['$event.target.value'])
    onInput(value: string): void {
        this.updateCounter(value.length);
    }

    private updateCounter(currentLength: number): void {
        const message = `${currentLength.toLocaleString('de-DE')}/${this.maxChars.toLocaleString('de-DE')}`;

        this.renderer.setProperty(this.counterElement, 'textContent', message);
    }
}
